import * as $ from 'jquery';

export default (
    function()
    {
        $('.participant-order-table').each(function() {
            $('select#fluffy_control_participants').on('change', function(){
                var $tableRow = $(this).closest('tr');
                var $inputs = $tableRow.find('input');

                if($(this).val() == ''){
                    $.each($inputs,function(){
                        $(this).prop('disabled', false);
                        $(this).val('');
                    });
                }else{
                    $.each($inputs, function(){
                        $(this).prop('disabled', true);
                        $(this).val('');
                    });
                }
            });
        });
    }($)
);
